export const useReturnConfirmation = () => {
  const inputNames = [
    "confirmation_title",
  ];

  return {
    inputNames,
  };
};
